const fontFamilySansSerif = "'Space Grotesk', sans-serif";
const fontFamilyHeadings = "'Inter', sans-serif";

const variables = {
  fontFamilyBase: fontFamilySansSerif,
  fontSizeBase: '16px',
  fontWeightBase: '400',

  // Headings
  headingsFontFamily: fontFamilyHeadings,
  headingsFontWeight: '400',
  headingsLineHeight: 1.1,
  fontSizeH1: 'clamp(2rem, 3.5vw, 3.5rem)',
  fontSizeH2: 'clamp(2rem, 4vw, 3.5rem)',
  fontSizeH3: 'clamp(1.5rem, 3vw, 2.5rem)',
  fontSizeH4: 'clamp(1.25rem, 2vw, 1.75rem)',
  fontSizeH5: '1.25rem',
  fontSizeH6: '1rem',

  // Buttons
  btnBorderRadius: '12px',
  btnBorderWidth: '0px',
  btnFontFamily: fontFamilyHeadings,
  btnFontWeight: 700,

  // Spacing
  baseSpacingUnit: '24px',
  halfSpacingUnit: '12px',

  // Others
  maxWidthFormContainer: '457px',
};

export default variables;
